import { cn } from '@growtherapy/sprout-ui';

import type { RemoteAudioVideoComponentProps } from '../../core/types';

export function ZoomRemoteAudioVideo({
  remoteParticipantId,
  videoRef,
  videoClassName,
  videoStyle,
}: RemoteAudioVideoComponentProps) {
  return (
    <video-player
      class={cn('fs-exclude', videoClassName)}
      style={videoStyle}
      data-testid={`remote-video:${remoteParticipantId}`}
      ref={videoRef}
    />
  );
}
